<div *ngIf="hasData" echarts [options]="chartOption" [merge]="chartOption" [autoResize]="true" style="height: 300px; width: 100%; max-width: 100%;"></div>
<div *ngIf="!hasData" style="height: 382px; display: flex; align-items: center; justify-content: center; background: white; border-radius: 8px;">
  <p style="color: #666; font-size: 16px;">No NDVI data available for the selected period</p>
</div>
